// app/frontend/lib/countries.ts

/**
 * Convert a 2-letter ISO country code to a flag emoji.
 * Uses Unicode regional indicator symbols.
 * Example: "US" -> "🇺🇸", "AU" -> "🇦🇺"
 */
export function getCountryFlag(countryCode?: string | null): string | null {
  if (!countryCode || countryCode.length !== 2) return null

  const code = countryCode.toUpperCase()

  // Regional indicator symbols start at U+1F1E6 (🇦)
  // Convert each letter to its regional indicator equivalent
  const firstChar = code.charCodeAt(0) - 65 + 0x1f1e6
  const secondChar = code.charCodeAt(1) - 65 + 0x1f1e6

  return String.fromCodePoint(firstChar, secondChar)
}

// Common country names for display
export const COUNTRY_NAMES: Record<string, string> = {
  US: 'United States',
  GB: 'United Kingdom',
  CA: 'Canada',
  AU: 'Australia',
  DE: 'Germany',
  FR: 'France',
  ES: 'Spain',
  IT: 'Italy',
  NL: 'Netherlands',
  BE: 'Belgium',
  AT: 'Austria',
  CH: 'Switzerland',
  SE: 'Sweden',
  NO: 'Norway',
  DK: 'Denmark',
  FI: 'Finland',
  PL: 'Poland',
  CZ: 'Czech Republic',
  PT: 'Portugal',
  IE: 'Ireland',
  NZ: 'New Zealand',
  JP: 'Japan',
  KR: 'South Korea',
  CN: 'China',
  IN: 'India',
  BR: 'Brazil',
  MX: 'Mexico',
  AR: 'Argentina',
  ZA: 'South Africa',
  SG: 'Singapore',
  HK: 'Hong Kong',
  TW: 'Taiwan',
  TH: 'Thailand',
  MY: 'Malaysia',
  PH: 'Philippines',
  ID: 'Indonesia',
  VN: 'Vietnam',
  RU: 'Russia',
  UA: 'Ukraine',
  IL: 'Israel',
  AE: 'United Arab Emirates',
  SA: 'Saudi Arabia',
  EG: 'Egypt',
  TR: 'Turkey',
  GR: 'Greece',
}

export function getCountryName(countryCode?: string | null): string | null {
  if (!countryCode) return null
  return COUNTRY_NAMES[countryCode.toUpperCase()] || countryCode.toUpperCase()
}
